var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{directives:[{name:"line-clamp",rawName:"v-line-clamp",value:(_vm.lineClamp),expression:"lineClamp"}],staticClass:"mb-0 card-header--title t-md",attrs:{"to":_vm.link,"title":_vm.textTitle},domProps:{"innerHTML":_vm._s(_vm.capitalizedTitle)}})
}
var staticRenderFns = []

export { render, staticRenderFns }